
const Transporter = ({ transporter }) => {
  const {
    id,
    name,
    code,
    description,
    food_transport_type,
    max_capacity,
    image_url,
  } = transporter

  return (
    <div className="row bat-row">
      <div className="col-sm-3">
        <img src={ image_url } className="img-responsive" />
      </div>
      <div className="col-sm-9">
        <div className="bat-name">{ name }</div>
        <div className="bat-code">{ code } </div>
        <div className="bat-description">{ description } </div>
        <div className="bat-capacity">Holding Capacity</div>
        <div className="bat-type">{ food_transport_type } Pans</div>
        <div className="bat-max">{ max_capacity }</div>
        <a
          href={`/quote_requests/basic_requests/new?selections%5BTransporter%5D=${id}`}
          style={{ color: "black" }}
        >
          <button className="btn-product">Quote Request</button>
        </a>
      </div>

    </div>
  )
}

export default Transporter
